<template>

  <div :class="[type == 1 ? 'sy_05' : 'sy_06']">
    <div class="middle">
      <h2 class="bt wow bounceInUp">
        <p><span><img src="images/sy_07.png" /></span>入驻企业 <strong>{{title}}</strong></p>
      </h2>
      <div :class="[type == 1 ? 'sy_05nav' : 'sy_06nav']">
        <a href="javascript:;" @click="searchCompany(1)" :class="['item', activeIndex == 1 ? 'cur' : '']">热门企业</a>
        <a href="javascript:;" @click="searchCompany(2)" :class="['item', activeIndex == 2 ? 'cur' : '']">最新入驻</a>
        <a :href="'enterprise.html?type=' + type" class="more">更多企业></a>
      </div>
      <companyList :type="type" :search-type="searchType"></companyList>
    </div>
  </div>
</template>

<script>
    // import api from '../api/api'
    // import layer from "layui-layer";
    import companyList from '../components/companyList'

    export default {
      name: 'indexCompanyList',
      props: ['title', 'type'],
      components:{
        companyList
      },
      data: function(){
        return {
          searchType: 1,
          activeIndex: 1
        }
      },
      created: function(){
        console.log("indexCompanyList created, type: " + this.type);
      },
      methods: {
        searchCompany: function (searchType) {
          this.searchType = searchType;
          this.activeIndex = searchType;
        }
      }
    }
</script>
